export enum EThemes {
  light = 'light',
  dark = 'dark',
}

export enum EThemeMode {
  old = 'old',
  new = 'new',
}

export type ThemeState = {
  selected?: EThemes
  initialTheme: EThemes
  mode: EThemeMode
}
